module.exports = __webpack_public_path__ + "static/img/super-chat-pass.6eacd262.png";